export default __webpack_public_path__ + "static/media/Tunic of the Rippling Lake.db8576bf.jpg";